import { render, staticRenderFns } from "./InvoiceRelated_Row_Total.vue?vue&type=template&id=210c00c0&"
import script from "./InvoiceRelated_Row_Total.vue?vue&type=script&lang=js&"
export * from "./InvoiceRelated_Row_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports